(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ad-conversion-landing"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tlj-campaign-landing')) {
    customElements.define(
      'tlj-campaign-landing',
      class CampaignLanding extends HTMLElement {
        connectedCallback() {
          this.finishButtons = Array.from(this.querySelectorAll('[data-campaign-finish]'));
          this.liveRegion = this.querySelector('[data-campaign-live]');

          this.finishButtons.forEach((button) => {
            button.addEventListener('click', () => {
              this.dataset.activeFinish = button.dataset.campaignFinish;
              this.finishButtons.forEach((candidate) => {
                const isActive = candidate === button;
                candidate.classList.toggle('is-active', isActive);
                candidate.setAttribute('aria-pressed', String(isActive));
              });
              if (this.liveRegion) this.liveRegion.textContent = button.dataset.liveCopy || '';
            });
          });

          this.preserveCampaignParameters();
          this.revealContent();
        }

        preserveCampaignParameters() {
          const source = new URLSearchParams(window.location.search);
          const campaignParameters = Array.from(source.entries()).filter(([key]) => key.startsWith('utm_'));
          if (!campaignParameters.length) return;

          this.querySelectorAll('[data-campaign-link]').forEach((link) => {
            try {
              const destination = new URL(link.href, window.location.origin);
              if (destination.origin !== window.location.origin) return;
              campaignParameters.forEach(([key, value]) => destination.searchParams.set(key, value));
              link.href = destination.toString();
            } catch (error) {
              return;
            }
          });
        }

        revealContent() {
          const items = Array.from(this.querySelectorAll('[data-campaign-reveal]'));
          if (!items.length) return;

          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
            items.forEach((item) => item.classList.add('is-visible'));
            return;
          }

          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target);
              });
            },
            { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
          );

          items.forEach((item) => observer.observe(item));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  if (!customElements.get('guide-article-navigation')) {
    customElements.define(
      'guide-article-navigation',
      class GuideArticleNavigation extends HTMLElement {
        connectedCallback() {
          const content = this.querySelector('[data-article-guide-content]');
          const navigation = this.querySelector('[data-article-guide-jumps]');
          const list = this.querySelector('[data-article-guide-list]');
          if (!content || !navigation || !list) return;

          const headings = Array.from(content.querySelectorAll(':scope > h2, :scope > h3'));
          headings.forEach((heading, index) => {
            const fallbackId = `article-answer-${index + 1}`;
            const baseId =
              heading.id ||
              heading.textContent
                .trim()
                .toLowerCase()
                .replace(/[^a-z0-9]+/g, '-')
                .replace(/(^-|-$)/g, '') ||
              fallbackId;
            let headingId = baseId;
            let duplicateIndex = 2;

            while (document.getElementById(headingId) && document.getElementById(headingId) !== heading) {
              headingId = `${baseId}-${duplicateIndex}`;
              duplicateIndex += 1;
            }
            heading.id = headingId;

            const item = document.createElement('li');
            const link = document.createElement('a');
            const number = document.createElement('span');
            const label = document.createElement('span');
            link.href = `#${headingId}`;
            number.setAttribute('aria-hidden', 'true');
            number.textContent = String(index + 1).padStart(2, '0');
            label.textContent = heading.textContent.trim();
            link.append(number, label);
            item.append(link);
            list.append(item);
          });

          if (list.children.length) navigation.hidden = false;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"]) return;
  try {
    
  if (!customElements.get('guide-page-navigation')) {
    customElements.define(
      'guide-page-navigation',
      class GuidePageNavigation extends HTMLElement {
        connectedCallback() {
          const article = this.querySelector('[data-guide-article]');
          const navigation = this.querySelector('[data-guide-jumps]');
          const list = this.querySelector('[data-guide-jump-list]');

          if (!article || !navigation || !list) return;

          const headings = Array.from(article.querySelectorAll(':scope > h2, :scope > h3'));
          const jumpHeadings = headings.filter((heading, index) => {
            if (index !== 0) return true;
            return !heading.textContent.toLowerCase().includes('complete guide');
          });

          jumpHeadings.forEach((heading, index) => {
            const baseId =
              heading.id ||
              heading.textContent
                .trim()
                .toLowerCase()
                .replace(/[^a-z0-9]+/g, '-')
                .replace(/(^-|-$)/g, '') ||
              `guide-section-${index + 1}`;
            let headingId = baseId;
            let duplicateIndex = 2;

            while (document.getElementById(headingId) && document.getElementById(headingId) !== heading) {
              headingId = `${baseId}-${duplicateIndex}`;
              duplicateIndex += 1;
            }

            heading.id = headingId;

            const item = document.createElement('li');
            const link = document.createElement('a');
            const number = document.createElement('span');
            const label = document.createElement('span');

            link.href = `#${headingId}`;
            number.className = 'tlj-guide__jump-index';
            number.setAttribute('aria-hidden', 'true');
            number.textContent = String(index + 1).padStart(2, '0');
            label.className = 'tlj-guide__jump-label';
            label.textContent = heading.textContent.trim();

            link.append(number, label);
            item.append(link);
            list.append(item);
          });

          if (list.children.length > 0) navigation.hidden = false;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
